export default "__VITE_ASSET__a0eaa97d__"